import { Route, Routes } from 'react-router-dom';
import './App.css';
import About from './page/about/About/About';
import Contact from './page/contact/Contact/Contact';
import Events from './page/events/Events/Events';
import Home from './page/home/Home/Home';
import Offer from './page/offer/Offer/Offer';
import Footer from './page/share/Footer/Footer';
import Header from './page/share/Header/Header';

function App() {
  return (
    <div className="container">
      <Header/>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/home" element={<Home/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/offer" element={<Offer/>} />
        <Route path="/events" element={<Events/>} />
        <Route path="/contact" element={<Contact/>} />
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
